export const AddIcon = () => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4007_7141)">
            <path
                d="M12.3164 7.43555C11.7664 7.43555 11.3164 7.88555 11.3164 8.43555V11.4355H8.31641C7.76641 11.4355 7.31641 11.8855 7.31641 12.4355C7.31641 12.9855 7.76641 13.4355 8.31641 13.4355H11.3164V16.4355C11.3164 16.9855 11.7664 17.4355 12.3164 17.4355C12.8664 17.4355 13.3164 16.9855 13.3164 16.4355V13.4355H16.3164C16.8664 13.4355 17.3164 12.9855 17.3164 12.4355C17.3164 11.8855 16.8664 11.4355 16.3164 11.4355H13.3164V8.43555C13.3164 7.88555 12.8664 7.43555 12.3164 7.43555ZM12.3164 2.43555C6.79641 2.43555 2.31641 6.91555 2.31641 12.4355C2.31641 17.9555 6.79641 22.4355 12.3164 22.4355C17.8364 22.4355 22.3164 17.9555 22.3164 12.4355C22.3164 6.91555 17.8364 2.43555 12.3164 2.43555ZM12.3164 20.4355C7.90641 20.4355 4.31641 16.8455 4.31641 12.4355C4.31641 8.02555 7.90641 4.43555 12.3164 4.43555C16.7264 4.43555 20.3164 8.02555 20.3164 12.4355C20.3164 16.8455 16.7264 20.4355 12.3164 20.4355Z"
                fill="#5C5C5C"
            />
        </g>
        <defs>
            <clipPath id="clip0_4007_7141">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.316406 0.435547)"
                />
            </clipPath>
        </defs>
    </svg>
);